module.exports = __webpack_public_path__ + "img/intelligent-security-solutionsimg-2.81bf73f0.png";